import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Components/pages/home/Home';
import Category from './Components/pages/category/Category';
import Details from './Components/pages/details/Details';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Category/:name" element={<Category />} />
          <Route path="/Category/:name/Details/:item" element={<Details />} />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
